import { render, staticRenderFns } from "./moduleHeader.vue?vue&type=template&id=1b56cf12&scoped=true&"
import script from "./moduleHeader.vue?vue&type=script&lang=js&"
export * from "./moduleHeader.vue?vue&type=script&lang=js&"
import style0 from "./moduleHeader.vue?vue&type=style&index=0&id=1b56cf12&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b56cf12",
  null
  
)

export default component.exports